var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ad-account-campaign-list'),_vm._v(" "),_c('new-campaign-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.account.vendor === 'Quora'),expression:"account.vendor === 'Quora'"}]}),_vm._v(" "),_c('ad-account-conversion-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasConversions),expression:"hasConversions"}]})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f96360e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/clients/AdAccountDetailsView.vue
// module id = 7wn+
// module chunks = 0